import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ConsultaAPI } from "../../../../../shared/http-requests";
import DropDownSearch, { makeDataSource } from "./DropDownSearch";

/**
 * @author Renan Salustiano <renan.salustiano@ter.grupomarista.org.br>
 * @param setProfessor {function}
 * @returns {JSX.Element}
 * @constructor
 */
const DropDownInputProfessor = ({setProfessor}) => {
    const [data, setData] = useState()
    const [pagination, setPagination] = useState();
    const [loading, setLoading] = useState(false);
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const [selected, setSelected] = useState(0);

    /**
     * Busca o dado pelo id caso seja um acesso direto pela url
     */
    useEffect(() => {
        const professor  = params.get('professor');

        if(professor){
            ConsultaAPI.buscarProfessorPorNome(professor).then((response) => {
                const { data } = response;
                if(data){

                    const config = {
                        id: 'cod_pessoa',
                        key: 'nome_pessoa',
                        text: 'nome_pessoa'
                    }

                    const parsedData = makeDataSource([data], config);
                    setProfessor(parsedData[0])
                    setSelected(data?.cod_pessoa)
                    setData(parsedData);
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    }, []);

    const buscarProfessores = (text = '', page= 1) => {
        setLoading(true);
        return  ConsultaAPI.buscarProfessores(text, page).then((response) => {
            const { data } = response;
            if(data){
                const { results, totalPages, currentPage } = data;
                setPagination({totalPages, currentPage});

                const config = {
                    id: 'cod_pessoa',
                    key: 'nome_pessoa',
                    text: 'nome_pessoa'
                }

                setData(makeDataSource(results, config));
            }
            setLoading(false);
        }).catch( error => {
            setLoading(false)
            console.log(error);
        });
    }

    return (
        <DropDownSearch
            placeholder="Selecione um professor"
            loading={loading}
            customFilter
            data={data}
            value={selected}
            onChange={buscarProfessores}
            onSelect={(item) => {
                setProfessor(item);
            }}
            pagination={pagination}
        />
    )
}

export default DropDownInputProfessor;
